<template>
  <div>
    <ContentHeader :showBack="true" />
    <div class="content-container" v-loading="loading">
      <div class="title">主题信息</div>
      <div class="content">
        <div class="item">
          <div class="re-title">
            <i>*</i>主题名称
          </div>
          <div class="re-content">
            <el-input v-model="formData.themeName" placeholder="请输入活动名称" />
          </div>
        </div>
        <div class="item">
          <div class="re-title">
            <i>*</i>活动时间
          </div>
          <div class="re-content">
            <el-date-picker
              v-model="formData.startDate"
              align="right"
              type="date"
              placeholder="开始时间"
              value-format="timestamp"
              @change="checkDate"
            ></el-date-picker>&nbsp;&nbsp;&nbsp;&nbsp;
            至
            &nbsp;&nbsp;&nbsp;&nbsp;
            <el-date-picker
              v-model="formData.endDate"
              align="right"
              type="date"
              placeholder="结束时间"
              value-format="timestamp"
              @change="checkDate"
              :picker-options="pickerOptions"
              default-time="23:59:59"
            ></el-date-picker>
          </div>
        </div>
        <div class="item">
          <div class="re-title">
            <i>*</i>渠道
          </div>
          <div class="re-content">
            <el-select v-model="formData.channelCode" placeholder="请选择渠道" :disabled="type === '02'">
              <el-option :label="item.channelName" :value="item.channelCode" v-for="item in channelList" :key="item.channelCode"></el-option>
            </el-select>
          </div>
        </div>
        <div class="item">
          <div class="re-title">
            <i>&nbsp;</i>所属组织级别
          </div>
          <div class="re-content">总部</div>
        </div>
        <div class="item">
          <div class="re-title">
            <i>*</i>陈列追踪方式
          </div>
          <div class="re-content checkbox-info">
            <el-button size="mini" type="primary" class="exec-cycle-btn">售点追踪</el-button>
          </div>
        </div>
        <div class="item">
          <div class="re-title">
            <i>*</i>最少执行时间（天）
          </div>
          <div class="re-content checkbox-info">
            <el-input-number v-model="formData.execDaysMin" :min="1" :precision="0" placeholder="请输入"></el-input-number>
          </div>
        </div>
        <div class="item">
          <div class="re-title">
            <i>*</i>最低打卡频次（天/次）
          </div>
          <div class="re-content checkbox-info">
            <el-input-number v-model="formData.execDaysCycle" :min="1" :precision="0" placeholder="请输入"></el-input-number>
          </div>
        </div>
        <div class="item">
          <div class="re-title">
            <i>*</i>可执行任务范围
          </div>
          <div class="re-content checkbox-info">
            <el-checkbox-group v-model="taskTypeScope" v-for="item in taskTypeScopeList" :key="item.code" class="checkbox-wrapper">
              <el-checkbox-button class="task-range-btn" size="mini" :label="item.code" @change="setTaskScope">{{item.item}}</el-checkbox-button>
            </el-checkbox-group>
          </div>
        </div>
        <div class="item">
          <div class="re-title">
            <i>*</i>费用返还方式
          </div>
          <div class="re-content">
            <div class="checkbox-info">
              <el-checkbox-group v-model="bonusTypeScope" v-for="item in bonusTypeScopeList" :key="item.code" class="checkbox-wrapper">
                <el-checkbox-button class="bonus-type-btn" size="mini" :label="item.code" @change="setBonusTypeScope">{{item.item}}</el-checkbox-button>
              </el-checkbox-group>
              <span style="font-size:12px;color:#409eff">
                <i class="el-icon-info"></i> 无交易售点
              </span>
            </div>
            <div class="checkbox-info">
              <el-checkbox-group v-model="bonusTypeScope" v-for="item in beesBonusTypeScopeList" :key="item.code" class="checkbox-wrapper">
                <el-checkbox-button class="bonus-type-btn" size="mini" :label="item.code" @change="setBonusTypeScope">{{item.item}}</el-checkbox-button>
              </el-checkbox-group>
              <span style="font-size:12px;color:#409eff">
                <i class="el-icon-info"></i> 有交易售点
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="handle-box" v-if="type === '01' && !themeDefineId">
        <el-button class="btn btn-red" :loading="btnLoading" @click="handleSubmit('0')">保存</el-button>
        <el-button class="btn btn-red" :loading="btnLoading" @click="handleSubmit('1')">提交</el-button>
      </div>
      <div class="handle-box" v-else>
        <el-button class="btn btn-red" :loading="btnLoading" @click="handleUpdate('0')">保存</el-button>
        <el-button class="btn btn-red" :loading="btnLoading" @click="handleUpdate('1')">提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import ContentHeader from '@/components/content-header'
import tradeApi from '@/api/trade.js'
import baseApi from '@/api/base'
import moment from 'moment'
export default {
  components: {
    ContentHeader
  },
  data () {
    return {
      type: '', // 01 新建  02 修改
      themeDefineId: '',
      loading: false,
      btnLoading: false,
      channelList: [],
      formData: {
        themeName: '',
        startDate: '',
        endDate: '',
        channelCode: '',
        execDaysMin: undefined,
        execDaysCycle: undefined,
        taskTypeScope: '',
        bonusTypeScope: ''
      },
      pickerOptions: {},
      taskTypeScopeList: [{ item: '堆箱', code: '01' }, { item: '货架', code: '02' }, { item: '冰柜', code: '03' }, { item: 'STR', code: '05' }],
      taskTypeScope: [],
      bonusTypeScopeList: [{ item: '线下现金返还', code: '02' }, { item: '线下免费酒返还', code: '03' }],
      bonusTypeScope: [],
      beesBonusTypeScopeList: [{ item: '先蜂购线上免费酒返还', code: '04' }, { item: '先蜂购线上抵扣金返还', code: '05' }]
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.pickerOptions = {
        disabledDate (time) {
          return time.getTime() < new Date(new Date(new Date().toLocaleDateString()).getTime()).getTime()
        }
      }
      this.getChannel()
      this.type = this.$route.query.type
      this.themeDefineId = this.$route.query.themeDefineId
      if (this.$route.query.themeDefineId) {
        this.getThemeDefineHqInfo()
      }
    },
    // 获取保存的活动信息
    getThemeDefineHqInfo () {
      this.loading = true
      tradeApi.getThemeDefineHqInfo({ themeDefineId: this.$route.query.themeDefineId }).then(res => {
        this.loading = false
        if (res.data.resultCode === '0') {
          this.formData = res.data.resultData.themeDefineInfo
          this.taskTypeScope = this.formData.taskTypeScope.split(',')
          this.bonusTypeScope = this.formData.bonusTypeScope.split(',')
        }
      }).catch(() => {
        this.loading = false
      })
    },
    // 验证活动时间是否合法
    checkDate () {
      if (this.formData.startDate && this.formData.endDate && this.formData.startDate > this.formData.endDate) {
        [this.formData.startDate, this.formData.endDate] = [this.formData.endDate, this.formData.startDate]
      }
    },
    // 渠道
    getChannel () {
      baseApi.getChannel().then(res => {
        if (res.data.resultCode === '0') {
          this.channelList = res.data.resultData.baseChannelList
        }
      })
    },

    // 执行任务范围
    setTaskScope () {
      this.formData.taskTypeScope = this.taskTypeScope.sort((a, b) => {
        return a - b
      }).join()
    },

    // 费用返还方式
    setBonusTypeScope () {
      this.formData.bonusTypeScope = this.bonusTypeScope.sort((a, b) => {
        return a - b
      }).join()
    },

    // 验证信息是否完整
    checkData () {
      this.formData.themeName = this.formData.themeName.trim()
      if (!this.formData.themeName) {
        this.$message.warning('请输入活动主题名称')
        return false
      }
      if (this.formData.themeName.length > 50) {
        this.$message.warning('活动名称最多五十字')
        return false
      }
      if (!this.formData.startDate) {
        this.$message.warning('请选择活动开始时间')
        return false
      }
      if (!this.formData.endDate) {
        this.$message.warning('请选择活动结束时间')
        return false
      }
      if (!this.formData.channelCode) {
        this.$message.warning('请选择活动渠道')
        return false
      }
      if (!this.formData.execDaysMin) {
        this.$message.warning('请输入最少执行时间')
        return false
      }
      let diffDate = moment(this.formData.endDate).diff(moment(this.formData.startDate), 'days', true)
      if (this.formData.execDaysMin > Math.floor(diffDate) + 1) {
        this.$message.warning('最少执行时间大于活动时间')
        return
      }
      if (!this.formData.execDaysCycle) {
        this.$message.warning('请输入最低打卡频次（天/次）')
        return false
      }
      if (!this.formData.taskTypeScope) {
        this.$message.warning('请选择可执行任务范围')
        return false
      }
      if (!this.formData.bonusTypeScope) {
        this.$message.warning('请选择费用返还方式')
        return false
      }
      // 费用返还方式选择先蜂购， 活动结束时间应为月最后一天
      // if (this.formData.bonusTypeScope.indexOf('04') !== -1 || this.formData.bonusTypeScope.indexOf('05') !== -1) {
      //   let year = new Date(this.formData.endDate).getFullYear()
      //   let month = new Date(this.formData.endDate).getMonth() + 1
      //   let newMonth = ++month
      //   if (newMonth === 13) {
      //     year++
      //     month = 1
      //   }
      //   // 当月最后一天
      //   let date = new Date(`${year}/${month}`).getTime() - 86400000
      //   if (this.formData.endDate < date) {
      //     this.$message.warning('费用返还方式已选择先蜂购，活动结束时间必须为该月最后一天')
      //     // eslint-disable-next-line no-useless-return
      //     return false
      //   }
      // }

      return true
    },

    // 新建活动 / 保存活动
    handleSubmit (type) {
      this.formData.saveFlag = type
      this.formData.approveEndDate = this.formData.endDate
      this.formData.tradePerfectTaskDefineList = []
      if (!this.checkData()) {
        return
      }

      this.taskTypeScope.sort((a, b) => {
        return a - b
      }).forEach(item => {
        let taskName = ''
        switch (item) {
          case '01':
            taskName = '堆箱'
            break
          case '02':
            taskName = '货架'
            break
          case '03':
            taskName = '冰柜'
            break
          case '05':
            taskName = 'STR'
            break
        }
        this.formData.tradePerfectTaskDefineList.push({
          taskType: item,
          taskName
        })
      })

      this.btnLoading = true
      tradeApi.themeDefineHq(this.formData).then(res => {
        this.btnLoading = false
        if (res.data.resultCode === '0') {
          this.$message.success('保存成功')
          this.$router.push({
            path: '/trade/perfect-hq-config-list'
          })
        }
      }).catch(() => {
        this.loading = false
      })
    },
    // 更新活动
    handleUpdate (type) {
      this.formData.saveFlag = type
      this.formData.approveEndDate = this.formData.endDate
      // this.formData.tradePerfectTaskDefineList = []

      if (!this.checkData()) {
        return
      }

      let list = []
      this.taskTypeScope.sort((a, b) => {
        return a - b
      }).forEach(item => {
        let taskName = ''
        switch (item) {
          case '01':
            taskName = '堆箱'
            break
          case '02':
            taskName = '货架'
            break
          case '03':
            taskName = '冰柜'
            break
          case '05':
            taskName = 'STR'
            break
        }
        let taskDefineId = ''
        this.formData.tradePerfectTaskDefineList.forEach(sItem => {
          if (sItem.taskType === item) {
            taskDefineId = sItem.taskDefineId
          }
        })
        list.push({
          taskType: item,
          taskName,
          taskDefineId
        })
      })

      this.formData.tradePerfectTaskDefineList = list
      let msg = type === '0' ? '保存成功' : '提交成功'
      this.btnLoading = true
      tradeApi.themeDefineHqUpdate(this.formData).then(res => {
        this.btnLoading = false
        if (res.data.resultCode === '0') {
          this.$message.success(`${msg}`)
          this.$router.push({
            path: '/trade/perfect-hq-config-list'
          })
        }
      }).catch(() => {
        this.loading = false
      })
    }
  }

}
</script>

<style lang="scss" scoped>
.el-radio-button {
  line-height: 60px;
}
::v-deep .el-input__icon {
  line-height: 30px !important;
}
.title {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 20px;
}
.content {
  background-color: #fff;
  border-radius: 10px;
  padding: 20px 40px;
  margin-bottom: 30px;
  .item {
    line-height: 60px;
    display: flex;
    border-bottom: 1px solid #ececec;
    .re-title {
      width: 200px;
      font-size: 16px;
      font-weight: 600;
      position: relative;
      .tips {
        font-size: 12px;
        color: #c8102d;
        position: absolute;
        left: 12px;
        top: 18px;
      }
      i {
        color: #c8102d;
        margin-right: 5px;
      }
    }
    .re-content {
      flex: 1;
      font-size: 14px;
      &::v-deep .el-input .el-input__inner {
        height: 30px;
      }
      ::v-deep .el-input-number__decrease,
      ::v-deep .el-input-number__increase {
        display: none;
      }
      .el-input-number {
        width: 80px;
        &::v-deep .el-input__inner {
          padding: 0;
        }
      }
      .el-input {
        width: 240px;
        height: 30px;
        line-height: 30px;
      }
      .el-select {
        width: 240px;
      }
      .el-date-picker {
        width: 220px;
      }
      .area {
        ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
        .el-checkbox__input.is-indeterminate .el-checkbox__inner {
          background-color: #409eff;
          border-color: #409eff;
        }
        ::v-deep .el-checkbox__inner:hover,
        .el-checkbox__input .el-checkbox__inner:focus {
          border-color: #409eff !important;
        }
        ::v-deep .el-checkbox__input.is-indeterminate .el-checkbox__inner {
          background-color: #409eff;
          border-color: #409eff;
        }
        display: flex;
        align-items: center;
        .checkbox-group {
          flex-basis: 80%;
        }
        .checkbox-checkAll {
          align-self: flex-start;
          flex-basis: 10%;
        }
      }
    }

    .checkbox-info {
      display: flex;
      flex-basis: 80%;
      flex-wrap: wrap;
      align-items: center;
      // padding: 10px 0;
      &::v-deep .el-checkbox-button__inner,
      &::v-deep .el-radio-button__inner,
      .exec-cycle-btn {
        height: 30px;
        padding: 7px 15px;
        border-radius: 4px;
        margin-right: 25px;
        // border-left: 1px solid #dcdfe6;
      }
      .checkbox-wrapper {
        position: relative;
        .task-range-btn {
          //   margin-right: 25px;
          &::v-deep .el-checkbox-button__inner {
            width: 80px;
          }
        }
        .bonus-type-btn {
          &::v-deep .el-checkbox-button__inner {
            width: 170px;
          }
        }
      }
    }
  }
}
.handle-box {
  width: 300px;
  margin: 0px auto 40px;
  display: flex;
  justify-content: space-around;
}
</style>
